import { ReactComponent as SortIcon } from "../../assets/icons/sort.svg";
import { ReactComponent as SortUp } from "../../assets/icons/sort-up.svg";
import { ReactComponent as SortDown } from "../../assets/icons/sort-down.svg";
import { useEffect, useState } from "react";
import { OrderDirection } from "../../models/common.models";

export interface ITableHeader<T> {
  field?: keyof T;
  title?: React.ReactNode;
  handleItem?: (item: T) => React.ReactNode;
  isHide?: boolean;
  align?: "left" | "right" | "center";
  width?: string;
}

function dynamicSort(columnName: string, sortType: OrderDirection) {
  let sortOrder = 1;
  if (sortType === OrderDirection.DESC) {
    sortOrder = -1;
  }
  return function (a: any, b: any) {
    let result = 0;
    if (columnName.match("[Dd]ate")) {
      result =
        new Date(a[columnName]) < new Date(b[columnName])
          ? -1
          : new Date(a[columnName]) > new Date(b[columnName])
          ? 1
          : 0;
    } else {
      result =
        a[columnName] < b[columnName]
          ? -1
          : a[columnName] > b[columnName]
          ? 1
          : 0;
    }
    return result * sortOrder;
  };
}

export interface ITableData<T> {
  data: T[];
  headersTable: ITableHeader<T>[];
}

const TableData = (props: ITableData<any>) => {
  const { headersTable, data } = props;
  const [sortParams, setSortParams] = useState<{
    field: string | null;
    sortType: OrderDirection | null;
  }>({
    field: null,
    sortType: null,
  });

  useEffect(() => {
    setSortParams({
      field: null,
      sortType: null,
    });
  }, [data]);

  const renderIcon = (field: string) => {
    let icon = <SortIcon />;

    if (sortParams.field !== field) {
      icon = <SortIcon />;
    } else if (
      sortParams.sortType === OrderDirection.DESC &&
      sortParams.field === field
    ) {
      icon = <SortUp />;
    } else {
      icon = <SortDown />;
    }

    return icon;
  };

  const handleSort = (field: string) => {
    const value =
      sortParams.field === field
        ? sortParams.sortType === OrderDirection.DESC
          ? OrderDirection.ASC
          : OrderDirection.DESC
        : OrderDirection.DESC;

    setSortParams({ field, sortType: value });
  };

  const dataSorts = () => {
    let prSortData = [...data];

    if (sortParams.field && sortParams.sortType)
      prSortData = prSortData.sort(
        dynamicSort(sortParams.field, sortParams.sortType)
      );

    return prSortData;
  };

  const dataSort = dataSorts();

  return (
    <table>
      <thead>
        <tr>
          {headersTable.map((item, key) => {
            if (item.isHide) {
              return <th key={key} style={{ width: item.width }}></th>;
            } else {
              return (
                <th
                  style={{ textAlign: item.align, width: item.width }}
                  key={key}
                  className={item.field ? "cur" : ""}
                  onClick={() => item.field && handleSort(item.field as string)}
                >
                  <div
                    className={item.field ? "d-flex align-items-center" : ""}
                  >
                    {item.title}
                    {item.field && (
                      <div className="sort">
                        {renderIcon(item.field as string)}
                      </div>
                    )}
                  </div>
                </th>
              );
            }
          })}
        </tr>
      </thead>
      <tbody>
        {dataSort.map((item) => (
          <tr key={item.id}>
            {headersTable.map((field, key) => {
              if (field.handleItem) {
                return (
                  <td
                    key={key}
                    style={{ textAlign: field.align, width: field.width }}
                  >
                    {field.handleItem(item)}
                  </td>
                );
              } else {
                return (
                  <td
                    style={{ textAlign: field.align, width: field.width }}
                    key={key}
                  >
                    {field.field ? item[field.field] : null}
                  </td>
                );
              }
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableData;
